import { gql } from '@zenbusiness/application-commons-graphql';

export const ENTITY_SELECTOR_QUERY = gql`
  query BusinessEntitySelector($accountUuid: UUID!, $limit: Int!) {
    businessEntitySelector(accountUuid: $accountUuid, limit: $limit) {
      businessEntities {
        name
        uuid
        hasNameReservation
      }
    }
  }
`;
